<template>
    <b-col>
         <div cols="12">
            <span class="divider"></span>
            <b-row >
                <b-col cols="3" class="text-left">
                    <!-- type -->
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.type") }}:</p>
                </b-col>
                <b-col cols="9" class="text-left">
                    <!-- Select... -->
                    <el-select v-model="info.type" :placeholder=' $t("messages.select")' >
                        <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
        </div>
         <div cols="12">
            <span class="divider"></span>
            <b-row >
                <b-col cols="3" class="text-left">
                    <!-- frequency -->
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.frequency") }}:</p>
                </b-col>
                <b-col cols="9" class="text-left">
                    <!-- select -->
                    <el-select v-model="info.freq" :placeholder=' $t("messages.select")' >
                        <el-option v-for="item in freqs" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
        </div>
        
     
        <b-row>
            <b-col cols="3" class="text-left">
                <!-- Notificantes -->
                <p class="mr-10 lh-30 mb-0">{{ $t("messages.notificates") }}:</p>
            </b-col>
            <b-col cols="9" class="text-left right">
             <b-button-group id="mode" class="menuOpt">
                 <!-- YES / NO -->
                    <b-button class="optInt" style="margin:0px;">{{ $t("messages.yes") }}</b-button>
                    <b-button class="optInt" style="margin:0px;">{{ $t("messages.no") }}</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <b-row cols="12">
            <b-col cols="3" class="text-left">
                <!-- Range -->
                <p class="mr-10 lh-30 mb-0">{{ $t("messages.range") }}</p>
            </b-col>
            <b-col cols="4" class="text-left">
                <number-input :step="0.1" :min="0" :max="1800" inline center controls size="small"></number-input>
                 <!-- minimum -->
                 <p class="xs"> {{ $t("messages.minValue") }}</p>
            </b-col>
            <b-col cols="5" class="text-left">
                <number-input :step="0.1" :min="0" :max="1800" inline center controls size="small" ></number-input>
                <!-- maximum -->
                <p class="xs"> {{ $t("messages.maxValue") }}</p> 
            </b-col>
        </b-row>
    </b-col>
</template>

<script>

export default {
    name: 'Alarm',
    props: {
        info:{}
    },
    data() {
        return {
            types: [
                {
                    value: 'ph',
                    label: 'Ph'
                },
            {
                    value: 'rx',
                    label: 'Rx'
                }
            ],
            freqs: [
                // Daily / Days / Weekly
                {
                    value: 86400,
                    label: this.$t("messages.daily")
                },
                {
                    value: 172800,
                    label: this.$t("messages.2daily")
                },
                {
                    value: 259200,
                    label: this.$t("messages.3daily")
                },
                {
                    value: 345600,
                    label: this.$t("messages.4daily")
                },
                {
                    value: 432000,
                    label: this.$t("messages.5daily")
                },
                {
                    value: 604800,
                    label: this.$t("messages.weekly")
                },
                {
                    value: 1209600,
                    label: this.$t("messages.2weekly")
                },
                {
                    value: 1814400,
                    label: this.$t("messages.3weekly")
                },
                {
                    value: 2419200,
                    label: this.$t("messages.4weekly")
                }
            ]
        }
    },

}
</script>



// WEBPACK FOOTER //
// src/components/utils/Alarm.vue